module.exports = __webpack_public_path__ + "img/journaliste-sportif-200819030235.a280107d.jpg";